export const CALENDLY_APPOINTMENT = {
  Ermias:
    "https://calendly.com/paradisebarbershop/visit-paradise-barber-shop-ermias",
  Fish: "https://calendly.com/fishbarbieri/visit-paradise-barbershop",
};
